const homepageVideosSwiper = new Swiper(".hp-videos-swiper", {
  slidesPerView: 1.8,
  spaceBetween: 16,
  breakpoints: {
    575: {
      slidesPerView: 2.5,
    },
    768: {
      slidesPerView: 3,
    },
    915: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 5,
    },
  },
  loop: true,
  autoplay: {
    delay: 1,
    disableOnInteraction: true,
  },
  speed: 9500,
});

